site.megamenu = {
	init:function() {
		var $mainmenu = $('#mainmenu');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					site.megamenu.setHeight();

					var $body = $('body');
					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');
						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},600);
					}
				}

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $megamenu[0].scrollHeight + 5;
			$megamenu.css('max-height', $megamenuHeight);
			$('#pageContainer').css('min-height', $megamenuHeight+142);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},600);
		}
		$body.removeClass('megamenu-open');
	}
};

// site.inits.push('site.megamenu.init()');